import { render, staticRenderFns } from "./CustomerAdd.vue?vue&type=template&id=dc5d2626&scoped=true&"
import script from "./CustomerAdd.vue?vue&type=script&lang=js&"
export * from "./CustomerAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc5d2626",
  null
  
)

export default component.exports